import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { DashboardWidgetId } from "@/lib/types/dashboard-widgets";

export async function invalidateUserTaskQueries(
  queryClient: QueryClient,
  tenantId?: number | null,
) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: [QueryKeys.UserTasks] }),
    queryClient.invalidateQueries({
      queryKey: [QueryKeys.WidgetData, tenantId, DashboardWidgetId.ToDo],
    }),
  ]);
}
